import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import loginimg from "../../assets/images/login.jpg"
import bg from '../../assets/images/bg.jpeg';
import bg2 from '../../assets/images/bg2.jpeg';
import bg3 from '../../assets/images/bg3.jpeg';
import bg4 from '../../assets/images/bg4.jpeg';
import bg6 from '../../assets/images/bg6.jpeg';
import bg8 from '../../assets/images/bg8.jpeg';
import bg9 from '../../assets/images/bg9.jpeg';
import bg10 from '../../assets/images/bg10.jpeg';
import BusinessInfo from '../Shared/BusinessInfo';
import { useSaasSession } from '../../saas/SessionContext';
import './MobileAuth.css';

const Login = () => {
    const [form, setForm] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const [saving, setSaving] = useState(false);
    const { login } = useSaasSession();
    const [backgroundImageUrl, setBackgroundImageUrl] = useState('');

    const navigate = useNavigate();
    const location = useLocation();
    const isMobile = location.pathname.startsWith('/mobile');
    const from = location.state?.from?.pathname || (isMobile ? '/mobile' : '/');

    const onSubmit = async event => {
        event.preventDefault();
        setSaving(true); setError('');
        try {
            const user = await login(form.email, form.password);
            navigate(user.forcePasswordChange ? (isMobile ? '/mobile/change-password' : '/change-password') : user.platformRole === 'platform_admin' ? (isMobile ? '/mobile/platform-admin' : '/platform-admin') : from, { replace: true });
        } catch (requestError) {
            setError(requestError.message);
        } finally {
            setSaving(false);
        }
    };

    useEffect(() => {
        if (isMobile) return;
        const imageUrls = [bg, bg2, bg3, bg4, bg6, bg8, bg9, bg10];
        const randomIndex = Math.floor(Math.random() * imageUrls.length);
        const randomImageUrl = imageUrls[randomIndex];
        setBackgroundImageUrl(randomImageUrl);

    }, [isMobile]);


    return (
        <div style={isMobile ? undefined : { backgroundImage: `url(${backgroundImageUrl})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }} className={`${isMobile ? 'mobile-auth mobile-auth--login' : ''} flex flex-col justify-center items-center h-screen`}>

            <div className={isMobile ? 'mobile-auth__card' : 'relative p-8 rounded-lg shadow-md w-96 backdrop-filter backdrop-blur-lg bg-opacity-30'}>
                <div className="absolute  bg-cover bg-center filter blur-md opacity-60"></div>
                <div className="flex flex-col items-center justify-center mb-6">
                    {isMobile && <p className="mobile-auth__eyebrow">Secure POS workspace</p>}
                    <h1 className='text-primary text-xl mb-4 font-bold'>Welcome To {BusinessInfo.name}</h1>
                    <img src={loginimg} alt="Logo" className={`${isMobile ? 'mobile-auth__logo' : 'w-32 h-32 rounded-full border-4 border-white'}`}
                    />
                </div>
                <form onSubmit={onSubmit}>
                    {location.state?.registered && <p role="status" className="text-sm text-green-700 mb-3">Registration submitted. Sign in to view your access status.</p>}
                    {error && <p role="alert" aria-live="assertive" className="text-sm text-red-600 mb-3">{error}</p>}
                    <div className="mb-4 bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-md p-2">
                        <div className='flex justify-between'>
                            <label htmlFor="email" className="block text-gray-600 mb-2">Email</label>
                            
                        </div>
                        <input id="email" name="email" required autoComplete="email" autoCapitalize="none" spellCheck={false} inputMode="email" value={form.email} onChange={event => setForm({ ...form, email: event.target.value })} type="email" className="w-full p-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300 backdrop-blur-sm" />

                    </div>
                    <div className="mb-4 bg-opacity-70 backdrop-filter backdrop-blur-lg rounded-md p-2">
                        <div className='flex justify-between'>
                            <label htmlFor="password" className="block text-gray-600 mb-2"> Password</label>
                            
                        </div>
                        <input id="password" name="password" required autoComplete="current-password" value={form.password} onChange={event => setForm({ ...form, password: event.target.value })} type="password" className="w-full p-2 border rounded-md focus:outline-none focus:ring focus:border-blue-300 backdrop-blur-sm" />

                    </div>
                    <div>
                        <button disabled={saving} type="submit" className={`${isMobile ? 'mobile-auth__submit' : 'w-full py-2 px-4 bg-primary font-bold text-white rounded-md hover:bg-danger focus:outline-none backdrop-blur-sm'}`}>{saving ? 'Signing in…' : 'Log in'}
                        </button>
                    </div>
                </form><p className={`${isMobile ? 'mobile-auth__switch' : 'text-sm text-center mt-4 text-white'}`}>New business? <Link className="underline" to={isMobile ? '/mobile/register' : '/register'}>Create an account</Link></p>
            </div>
        </div>
    );
};

export default Login;


// src/App.js
// import React from 'react';

// const App = () => {
//   return (
//     <div>
//         <div className="2-96 shodow-xl mx-auto text-white bg-clip-padding backdrop-filter bg-white bg-opacity-10
//         backdrop-blur-md mt-20 py-10 px-8 rounded-md">
//             <div className="text-enter text-2xl">Login</div>
//             <form action="" className="mt-6">
//                 <div className="mb-4">

//                 </div>
//             </form>

//         </div>
//     </div>
//   );
// };

// export default App;




// const Login = () => {
//     const { register, handleSubmit, watch, formState: { errors } } = useForm();
//     const [signInWithEmailAndPassword, user, loading, error,] = useSignInWithEmailAndPassword(auth);

//     // const [token]= useWebToken(user);

//     const navigate = useNavigate();
//     const location = useLocation();
//     const from = location.state?.from?.pathname || "/";

//     if(user){
//         navigate(from, { replace: true });
//     }

//     const onSubmit = data => {
//         signInWithEmailAndPassword(data.email, data.password);
//     };
//     return (
//         <div>
//             <div className='flex justify-center items-center my-28'>
//                 <div className='w-9/12 lg:w-4/12 md:w-1/2 shadow-2xl p-12'>
//                 <form onClick={handleSubmit(onSubmit)}>
//                     <img className='w-2/4 mx-auto' src={login} alt="" />
//                     <div class="form-control">
//                         <label class="label">
//                             <span class="label-text">ইমেইল</span>
//                         </label>
//                         <input {...register("email", { required: true, })} type="email" class="input input-bordered" />
//                         <label class="label">
//                             <span class="label-text-alt text-red-500">{errors.email && <span>This field is required</span>}</span>
//                         </label>
//                     </div>
//                     <div class="form-control">
//                         <label class="label">
//                             <span class="label-text">পাসওয়ার্ড</span>
//                         </label>
//                         <input {...register("password", { required: true })} type="password" class="input input-bordered" />
//                         <label class="label">
//                             <span class="label-text-alt text-red-500">{errors.password && <span>This field is required</span>}</span>
//                         </label>
//                     </div>
//                     <button type='submit' className='btn btn-error w-full text-white font-bold'>লগইন</button>
//                 </form>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Login;

// src/App.js
// src/App.js
